import { render } from "./PresumedGained.vue?vue&type=template&id=994429a6"
import script from "./PresumedGained.vue?vue&type=script&lang=js"
export * from "./PresumedGained.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/moko.africa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__